import gql from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const chatLgbtPage = gql`
  ${seoFragment}
  query getChatLgbtPage($locale: SiteLocale) {
    chatLgbt(locale: $locale) {
      id
      seo {
        ...SeoFragment
      }
      welcomeMessage
      promptIniziali {
        text
      }
      introVideoUrl
    }
  }
`
